import LangEnum from '../../../../lang/LangEnum';

export enum DateShortcut {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  QUARTER = 'CURRENT_QUARTER',
  YEAR = 'CURRENT_YEAR',
  SEVEN_DAYS = 'SEVEN_DAYS',
  THIRTY_DAYS = 'THIRTY_DAYS',
  SIXTY_DAYS = 'SIXTY_DAYS',
  NINETY_DAYS = 'NINETY_DAYS',
  TWELVE_MONTHS = 'TWELVE_MONTHS',
  ALL_PERIOD = 'ALL_PERIOD',
}

export interface DateRangeValue {
  initialDate: Date | null;
  finalDate: Date | null;
  shortcutStep: number;
}

export interface DateShortcutValue {
  shortcut: DateShortcut | null;
  shortcutStep: number;
}

export type DateRangeFilterValue = DateRangeValue | DateShortcutValue;

export interface DateShortcutRange {
  name: DateShortcut;
  initialDate: Date | null;
  finalDate: Date | null;
  title: LangEnum;
}
